import { FormItemHiddenUi } from "../../../ui/FormItemHiddenUi";
import { Col, Form, Input, Row } from "antd";
import { RutaPadreSelect } from "../../modulo/RutaPadreSelect";
import { SwitchUi } from "../../../ui/SwitchUi";
import IconPicker from "../../../ui/IconPickerUi";

export const RutaForm = () => {
  const form = Form.useFormInstance();
  const eslink = Form.useWatch("eslink", form);

  const handleChangeEsLink = (value) => {
    console.log(value);
    if (value) form.setFieldValue("icono", null);
    else form.setFieldValue("componente", null);
  };
  return (
    <>
      <FormItemHiddenUi name="id" />
      <FormItemHiddenUi name="orden" />
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item
            name="nombre"
            label="Nombre"
            rules={[{ required: true, message: "El nombre es obligatorio" }]}
          >
            <Input placeholder="Ingrese el nombre" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item name="rutapadre" label="Ruta padre">
            <RutaPadreSelect />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col span={12}>
          <Form.Item
            name="eslink"
            label="¿Es un enlace?"
            valuePropName="checked"
          >
            <SwitchUi onChange={handleChangeEsLink} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="esvisible"
            label="¿Es visible en el menú?"
            valuePropName="checked"
          >
            <SwitchUi />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={24}>
          <Form.Item
            name="path"
            label="Path"
            rules={[{ required: true, message: "La ruta es obligatorio" }]}
          >
            <Input placeholder="Ingrese la ruta por favor" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={8} style={!eslink && { display: "none" }}>
        <Col span={24}>
          <Form.Item
            name="componente"
            label="Componente"
            rules={[
              { required: eslink, message: "El componente es obligatorio" },
            ]}
          >
            <Input placeholder="Nombre del componente" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={24}>
          <Form.Item name="icono" label="Icono">
            <IconPicker placeholder="Buscar el icono asociado" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
